import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Outlet, matchPath, useLocation, Link as RouterLink } from 'react-router-dom';

import { styled, useTheme } from '@mui/material/styles';

import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText
} from '@mui/material';

import GlobeIcon from '../../icons/GlobeIcon';
import ColorsIcon from '../../icons/ColorsIcon';

import Main from '../../styled/Main';

import DrawerHeader, { DrawerTitle } from '../../styled/DrawerHeader';
import { Helmet } from 'react-helmet';

import WallpaperIcon from '@mui/icons-material/Wallpaper';

import apiClient from "../../../services/api";

const drawerWidth = 240;

function Settings() {
    const theme = useTheme();
    const { t } = useTranslation();

    const [isTranslationsModuleActive, setIsTranslationsModuleActive] = useState(false);
    const [isColorGroupsModuleActive, setIsColorGroupsModuleActive] = useState(false);
    const [isProjectViewsModuleActive, setIsProjectViewsModuleActive] = useState(false);
    const [isBackgroundsModuleActive, setIsBackgroundModulesActive] = useState(false);

    const modules = useSelector((state) => state.auth.modules);

    useEffect(() => {
        apiClient.post('/api/modules/check', { name: 'translations' }).then(response => { setIsTranslationsModuleActive(response?.data?.success) });
        apiClient.post('/api/modules/check', { name: 'colorGroups' }).then(response => { setIsColorGroupsModuleActive(response?.data?.success) });
        apiClient.post('/api/modules/check', { name: 'publicViews' }).then(response => { setIsProjectViewsModuleActive(response?.data?.success) });
        apiClient.post('/api/modules/check', { name: 'backgrounds' }).then(response => { setIsBackgroundModulesActive(response?.data?.success) });
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const items = [
        {
            title: t("Translations"),
            href: "/app/settings/translations",
            icon: GlobeIcon,
            enabled: isTranslationsModuleActive
        },
        {
            title: t("Color Groups"),
            href: "/app/settings/colors",
            icon: ColorsIcon,
            enabled: isColorGroupsModuleActive
        },
        {
            title: t("Project views"),
            href: "/app/settings/project-views",
            icon: ColorsIcon,
            enabled: isProjectViewsModuleActive
        },
        {
            title: t("Backgrounds"),
            href: "/app/settings/backgrounds",
            icon: WallpaperIcon,
            enabled: isBackgroundsModuleActive
        }
    ];

    const location = useLocation();

    const Layout = () => {
        return (
            <Box sx={{ display: 'flex', height: '100%' }}>
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                        padding: '0px',
                        borderLeft: '1px solid ' + theme.palette.settingsDrawer.borderLeft.color
                    }}
                    variant="persistent"
                    anchor="left"
                    open={true}
                    PaperProps={{ sx: {
                        position: "relative",
                        padding: '0px',
                        backgroundColor: theme.palette.settingsDrawer.background
                    }}}
                >
                    <DrawerHeader padding>
                        <DrawerTitle>
                            <Trans>Settings</Trans>
                        </DrawerTitle>
                    </DrawerHeader>
                    <List>
                        {items.map((item, index) => (
                            item.enabled && (
                                <ListItem key={index} disablePadding>
                                    <ListItemButton component={RouterLink} to={item.href}>
                                        <item.icon
                                            isActive={!!matchPath({ path: item.href, end: false }, location.pathname)}
                                            style={{ color: !!matchPath({ path: item.href, end: false }, location.pathname) ? theme.palette.primary.main : theme.palette.icons.color }}
                                        />
                                        <ListItemText
                                            primaryTypographyProps={{ fontWeight: 'bold' }}
                                            primary={item.title}
                                            style={{
                                                paddingLeft: '15px',
                                                fontWeight: 'bold'
                                            }}
                                            sx={{
                                                fontWeight: 'bold',
                                                color: theme.palette.settingsDrawer.color,
                                                    ...((item.href 
                                                    ? !!matchPath({ path: item.href, end: false }, location.pathname)
                                                    : false
                                                ) && {
                                                    color: "#40B2E0",
                                                    "&:hover": { color: "#40B2E0" }
                                                })
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            )
                        ))}
                    </List>
                </Drawer>
                <Main open={true} drawerWidth={drawerWidth} padding style={{ overflowY: 'auto' }}>
                    <Outlet />
                </Main>
            </Box>
        );
    }

    return <>
        <Helmet><title>{t("Settings")}</title></Helmet>
        <Layout />
    </>;
}

export default Settings;
